/**
 * 页面配置文件
 * 用于动态配置首页的各个组件及其数据
 */

export const pageConfig = {
  // 页面基础配置
  page: {
    title: '健康甄选福利卡',
    // backgroundImage: 'https://hnenjoy.oss-cn-shanghai.aliyuncs.com/static/img/202601/5508b7ec27d653edb2da690e76ac7807.jpg',
    backgroundColor: '#F0315C'
  },
  
  // 组件列表（按顺序渲染）
  components: [
    {
      id: 'banner',
      type: 'BannerSection',
      visible: true,
      data: {
        decorationImage: require('@/assets/images/decoration.png'),
        bannerImage: 'https://hnenjoy.oss-cn-shanghai.aliyuncs.com/static/img/202601/e82649a1dc9a8022378bbc08d9bad840.jpg',
        clickUrl: '/demo.html'
      }
    },
    {
      id: 'marquee',
      type: 'MarqueeNotice',
      visible: false,
      data: {
        notices: [
          '广东用户136****5876前30秒已开通',
          '河北用户152****7666前1分钟已开通',
          '江西用户138****1796前2分钟开通',
          '浙江用户136****6856前3分钟开通',
          '上海用户180****0660前4分钟开通',
          '江苏用户159****8867前5分钟开通',
          '新疆用户131****9867前30秒开通',
          '湖北用户189****6769前1分钟开通',
          '黑龙江用户157****6623前2分钟开通',
          '四川用户177****9823前3分钟开通',
          '福建用户135****5786前5分钟开通'
        ],
        speed: 1
      }
    },
    {
      id: 'countdown',
      type: 'CountdownTimer',
      visible: false,
      data: {
        endTime: 600,
        title: '活动倒计时'
      }
    },
    {
      id: 'form',
      type: 'FormSection',
      visible: true,
      data: {
        phonePlaceholder: '请输入领取权益的手机号码',
        submitButtonImage: require('@/assets/images/submit-btn.png'),
        handGifUrl: 'https://wechat.1haonet.com/h5/v2.7.6/img/d-hand1-showPreferential.966b5b7e.gif',
        priceText: '100元购药金+音视频会员N选一，19.9元/月',
        priceTextColor: '#007BFF', // 价格文字颜色
        flowText: '领取流程：输入手机号码→点击办理该产品→领取会员',
        flowTextColor: '#006AFF', // 流程文字颜色
        showCustomerService: true, // 是否显示客服电话
        customerService: {
          label: '客服电话：',
          phone: '400-xxx-xxxx',
          color: '#E7401E' // 客服电话颜色
        },
        agreement: {
          privacyUrl: '/privacy.html',
          serviceUrl: '/agreement.html',
          privacyTitle: '个人信息保护政策',
          serviceTitle: '自动续费--连续订阅服务协议'
        }
      }
    },
    {
      id: 'priceSelector',
      type: 'PriceSelector',
      visible: true,
      // 方式1：图片模式（带activeImage和image）
      data: {
        displayMode: 'image', // image-图片, text-文字, mixed-图文混合
        defaultIndex: 0, // 默认选中第一个
        showCheckMark: true, // 显示选中标记
        showSelectedInfo: true, // 显示选中信息
        options: [
          {
            label: '连续包月',
            image: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857102650.png',
            activeImage: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857106815.png',
            price: {
              symbol: '¥',
              value: '19.9',
              unit: '/月'
            },
            billing: '连续包月，可随时取消',
            mode: 'subscription'
          },
          {
            label: '年费会员',
            image: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857111493.png',
            activeImage: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857114994.png',
            price: {
              symbol: '¥',
              value: '199',
              unit: '/年'
            },
            billing: '一次性付费，有效期一年',
            mode: 'yearly'
          }
        ]
      }
      // 方式2：文字模式
      // data: {
      //   displayMode: 'text',
      //   defaultIndex: 0,
      //   textStyle: {
      //     color: 'rgba(255, 255, 255, 0.5)', // 未选中：半透明白色
      //     fontSize: '0.28rem',
      //     backgroundColor: 'transparent'
      //   },
      //   activeTextStyle: {
      //     color: '#FFFFFF', // 选中：纯白色
      //     fontSize: '0.28rem',
      //     backgroundColor: 'transparent'
      //   },
      //   priceStyle: {
      //     fontSize: '0.32rem',
      //     fontWeight: '600'
      //   },
      //   options: [...]
      // }
      //   billing: {
      //     mode: 'subscription', // monthly, quarterly, yearly, onetime, subscription
      //     text: '连续包月'
      //   },
      //   textStyle: {
      //     backgroundColor: '#F8F9FA',
      //     padding: '0.2rem',
      //     textAlign: 'center'
      //   }
      // }
      // 方式3：图文混合模式
      // data: {
      //   displayMode: 'mixed',
      //   image: {
      //     url: 'https://.../product.png',
      //     alt: '产品图片'
      //   },
      //   product: {
      //     name: '健康甄选福利卡'
      //   },
      //   price: {
      //     show: true,
      //     value: 19.9,
      //     color: '#E7401E'
      //   },
      //   overlay: {
      //     backgroundColor: 'rgba(0, 0, 0, 0.6)',
      //     color: '#fff'
      //   }
      // }
    },
    {
      id: 'benefits',
      type: 'BenefitsSection',
      visible: true,
      data: {
        headerTitle: '客服电话：',
        phoneNumber: '400-xxx-xxxx',
        tabs: [
          {
            name: '福利一',
            icon: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857102650.png',
            activeIcon: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857106815.png'
          },
          {
            name: '福利二',
            icon: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857111493.png',
            activeIcon: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857114994.png'
          }
        ],
        images: [
          require('@/assets/images/benefit1.png'),
          require('@/assets/images/benefit2.png')
        ]
      }
    },
    {
      id: 'orderNotice',
      type: 'OrderNotice',
      visible: true,
      // 方式1：使用富文本（推荐，后台配置更灵活）
      data: {
        // richText: `
        //   <h2>订购须知</h2>
        //   <p><strong>1、服务说明</strong></p>
        //   <p>本服务为连续包月服务，订购后立即生效。</p>
        //   <p><strong>2、计费方式</strong></p>
        //   <p>每月自动扣费19.9元，可随时取消续订。</p>
        //   <p><strong>3、注意事项</strong></p>
        //   <ul>
        //     <li>每个手机号仅限参与一次</li>
        //     <li>当月退订后次月不再扣费</li>
        //     <li>权益需在30天内领取</li>
        //   </ul>
        // `
      }
      // 方式2：使用结构化数据（兼容旧配置）
      // data: {
      //   title: '订购须知',
      //   warnings: ['警告信息1', '警告信息2'],
      //   productInfo: [
      //     { label: '商品名称', value: '健康甄选福利卡' },
      //     { label: '资费', value: '19.9元/月', isPrice: true }
      //   ],
      //   benefits: [...],
      //   notices: [...],
      //   footerText: '底部说明文字'
      // }
    }
  ]
}

// 默认配置（用于接口失败时）
export const defaultConfig = {
  page: {
    title: '健康甄选福利卡',
    backgroundImage: 'https://static-cos.jetmobo.com/image/content-h5/20250714/1752496056578.jpg',
    backgroundColor: '#fff'
  },
  components: [
    {
      id: 'banner',
      type: 'BannerSection',
      visible: true,
      data: {}
    },
    {
      id: 'form',
      type: 'FormSection',
      visible: true,
      data: {}
    }
  ]
}
